import { getUrlParam } from "../../lib/helper";
import { Paper, Stack, Typography } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { blue_chart_color } from "../../lib/theme";
import { sum } from "lodash";

export interface CommonHorizontalBarProps {
  title?: string;
  items: { label: string; value: number }[];
}

export default function DetailsHorizontalBar(props: CommonHorizontalBarProps) {
  const mobile = getUrlParam("mobile");
  const { title, items } = props;
  const labels = (items || []).map((item) => item.label);
  const values = (items || []).map((item) => item.value);
  const valuesSum = sum(values);
  return (
    <Stack spacing={2}>
      {title && (
        <Paper elevation={mobile ? 0 : 2} className="padding-small">
          <Typography variant={"h6"} textAlign={"center"}>
            {title} {valuesSum}
          </Typography>
        </Paper>
      )}
      <Paper elevation={mobile ? 0 : 2} className="padding-normal">
        <Bar
          style={{ height: 345 }}
          options={{
            responsive: true,
            maintainAspectRatio: !!mobile,
            indexAxis: "y",
            plugins: {
              legend: { display: false },
            },
            scales: {
              x: {
                grid: { display: false },
              },
              y: {
                grid: { display: false },
              },
            },
          }}
          data={{
            labels: labels,
            datasets: [
              {
                data: values,
                backgroundColor: blue_chart_color,
                borderRadius: 5,
                barThickness: "flex",
              },
            ],
          }}
        />
      </Paper>
    </Stack>
  );
}
